import { useState, useEffect, useContext } from 'react'
import { NavLink, useNavigate } from "react-router-dom";
import Menu from '../../components/DashboardAdmin/Menu';
import AuthContext from '../../Context/auth';
import axios from 'axios';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  RadialLinearScale,
  ArcElement
} from 'chart.js';
import { Line, Bar, PolarArea } from 'react-chartjs-2';
import LoadData from '../../components/Global/LoadData';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Filler,
  Legend,
  ArcElement,
  RadialLinearScale
);


let datetoday = new Date();
let daytodayFormat = datetoday.toISOString().split("T")[0];

let date1 = new Date();
date1.setDate(date1.getDate() - 1);
let day1Format = date1.toISOString().split("T")[0];

let date2 = new Date();
date2.setDate(date2.getDate() - 2);
let day2Format = date2.toISOString().split("T")[0];


let date3 = new Date();
date3.setDate(date3.getDate() - 3);
let day3Format = date3.toISOString().split("T")[0];


let date4 = new Date();
date4.setDate(date4.getDate() - 4);
let day4Format = date4.toISOString().split("T")[0];



let date5 = new Date();
date5.setDate(date5.getDate() - 5);
let day5Format = date5.toISOString().split("T")[0];



let date6 = new Date();
date6.setDate(date6.getDate() - 6);
let day6Format = date6.toISOString().split("T")[0];


function subtractMonth(date, months) {
  let d = date?.getDate();
  date?.setMonth(date?.getMonth() - months);
  if (date?.getDate() != d) {
    date?.setDate(0);
  }
  return date?.toISOString()?.split("T")?.[0]?.slice(0, -3);
}


let monthtoday = new Date();
let monthtodayFormat = monthtoday.toISOString().split("T")[0].slice(0, -3);

let month1 = new Date();
let month1Format = subtractMonth(month1, 1);

let month2 = new Date();
let month2Format = subtractMonth(month2, 2);

let month3 = new Date();
let month3Format = subtractMonth(month3, 3);

let month4 = new Date();
let month4Format = subtractMonth(month4, 4);

let month5 = new Date();
let month5Format = subtractMonth(month5, 5);

let month6 = new Date();
let month6Format = subtractMonth(month6, 6);

let month7 = new Date();
let month7Format = subtractMonth(month7, 7);

let month8 = new Date();
let month8Format = subtractMonth(month8, 8);

let month9 = new Date();
let month9Format = subtractMonth(month9, 9);

let month10 = new Date();
let month10Format = subtractMonth(month10, 10);

let month11 = new Date();
let month11Format = subtractMonth(month11, 11);



const TopProducts = () => {

  const { Auth, setAuth } = useContext(AuthContext);
  let navigate = useNavigate();


  const [TotalClients, setTotalClients] = useState('')
  const [TotalClientsPerCat, setTotalClientsPerCat] = useState('')

  const [WhatsApp, setWhatsApp] = useState('')


  const [TotlaViewsPerDay, setTotlaViewsPerDay] = useState('')
  const [TotlaViewsPerMonth, setTotlaViewsPerMonth] = useState('')
  const [Mostvisitedhours, setMostvisitedhours] = useState('')
  const [MostvisitedDays, setMostvisitedDays] = useState('')


  const [DateSearch, setDateSearch] = useState(new Date().toISOString().split('T')[0])

  const DaysFr = {
    "Monday": "Lundi",
    "Tuesday": "Mardi",
    "Wednesday": "Mercredi",
    "Thursday": "Jeudi",
    "Friday": "Vendredi",
    "Saturday": "Samedi",
    "Sunday": "Dimanche"
  }


  const options = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: false,
      title: {
        display: true,
        text: '# Commandes Par Jour',
      },
    },
  };

  const optionstwo = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: false,
      title: {
        display: true,
        text: 'Commandes Par Mois',
      },
    },
  };

  const optionsthree = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: false,
      title: {
        display: true,
        text: 'Horaires les plus visités',
      },
    },
  };

  const optionsfour = {
    // responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: false,
      title: {
        display: true,
        text: 'Jours les plus visités',
      },
    },
  };

  const labels = [day6Format, day5Format, day4Format, day3Format, day2Format, day1Format, daytodayFormat];

  const data = {
    labels,
    datasets: [
      {
        fill: true,
        label: 'Commandes',
        data: [TotlaViewsPerDay?._6day, TotlaViewsPerDay?._5day, TotlaViewsPerDay?._4day, TotlaViewsPerDay?._3day, TotlaViewsPerDay?._2day, TotlaViewsPerDay?._1day, TotlaViewsPerDay?.today],
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };



  const labels2 = [month11Format, month10Format, month9Format, month8Format, month7Format, month6Format, month5Format, month4Format, month3Format, month2Format, month1Format, monthtodayFormat];

  // const data2 = {
  //   labels2,
  //   datasets: [
  //     {
  //       fill: true,
  //       label: 'Visiteurs Par Mois',
  //       data: [TotlaViewsPerMonth?.Months_11,TotlaViewsPerMonth?.Months_10,TotlaViewsPerMonth?.Months_9,TotlaViewsPerMonth?.Months_8,TotlaViewsPerMonth?.Months_7, TotlaViewsPerMonth?.Months_6, TotlaViewsPerMonth?.Months_5, TotlaViewsPerMonth?.Months_4, TotlaViewsPerMonth?.Months_3, TotlaViewsPerMonth?.Months_2, TotlaViewsPerMonth?.Months_1,TotlaViewsPerMonth?.Months],
  //       borderColor: '#f783ee',
  //       backgroundColor: '#ff6db678',
  //     },
  //   ],
  // };

  const data2 = {
    labels: labels2,
    datasets: [{
      label: 'Commandes',
      data: [TotlaViewsPerMonth?.Months_11, TotlaViewsPerMonth?.Months_10, TotlaViewsPerMonth?.Months_9, TotlaViewsPerMonth?.Months_8, TotlaViewsPerMonth?.Months_7, TotlaViewsPerMonth?.Months_6, TotlaViewsPerMonth?.Months_5, TotlaViewsPerMonth?.Months_4, TotlaViewsPerMonth?.Months_3, TotlaViewsPerMonth?.Months_2, TotlaViewsPerMonth?.Months_1, TotlaViewsPerMonth?.Months],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(255, 159, 64, 0.2)',
        'rgba(255, 205, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(201, 203, 207, 0.2)'
      ],
      borderColor: [
        'rgb(255, 99, 132)',
        'rgb(255, 159, 64)',
        'rgb(255, 205, 86)',
        'rgb(75, 192, 192)',
        'rgb(54, 162, 235)',
        'rgb(153, 102, 255)',
        'rgb(201, 203, 207)'
      ],
      borderWidth: 1
    }]
  };


  const labels3 = [Mostvisitedhours?.[0]?.hour?.toString()?.padStart(2, "0") + ":00", Mostvisitedhours?.[1]?.hour?.toString()?.padStart(2, "0") + ":00", Mostvisitedhours?.[2]?.hour?.toString()?.padStart(2, "0") + ":00"];
  const data3 = {
    labels: labels3,
    datasets: [
      {
        type: 'line',
        fill: true,
        label: 'Commandes',
        data: [Mostvisitedhours?.[0]?.visitors, Mostvisitedhours?.[1]?.visitors, Mostvisitedhours?.[2]?.visitors],
        borderColor: '#ff6384',
        backgroundColor: "rgb(255 99 132 / 18%)",
        pointStyle: 'circle',
        pointRadius: 10,
        pointHoverRadius: 15
      },
    ],
  };


  const labels4 = [DaysFr?.[MostvisitedDays?.[0]?.day], DaysFr?.[MostvisitedDays?.[1]?.day], DaysFr?.[MostvisitedDays?.[2]?.day]];
  const data4 = {
    labels: labels4,
    datasets: [
      {
        type: 'polarArea',
        fill: true,
        label: 'Visiteurs',
        data: [MostvisitedDays?.[0]?.visitors, MostvisitedDays?.[1]?.visitors, MostvisitedDays?.[2]?.visitors],
        // borderColor: '#ff6384',
        backgroundColor: ["#7288dbb0", "#1b6b7694", "#5a559fa6"],
        // pointStyle: 'circle',
        // pointRadius: 10,
        // pointHoverRadius: 15
      },
    ],
  };




  // useEffect(() => {


  //   if (Auth) {
  //     console.log('hi!');

  //   }else{
  //     console.log('no!'); 
  //     return navigate("/");
  //   }


  // }, [Auth])

  const [MenuShow, setMenuShow] = useState(true)

  const [windowSize, setWindowSize] = useState(getWindowSize());


  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  console.log(windowSize);

  // const [MobileScreen, setMobileScreen] = useState(windowSize.innerWidth > 992 ? false : true)

  const ValidateToken = async (GetAllData) => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/get_total_clients${DateSearch && !GetAllData ? '?date_start=' + DateSearch : ''}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Auth?.token}`
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTotalClients(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }

  const GetClientsPerCat = async (GetAllData) => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/get_total_clients_per_cat${DateSearch && !GetAllData ? '?date_start=' + DateSearch : ''}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Auth?.token}`
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTotalClientsPerCat(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }


  const [Top3, setTop3] = useState([])
  const GetTop3Agents = async (GetAllData) => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/get_top_agents${DateSearch && !GetAllData ? '?date_start=' + DateSearch : ''}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Auth?.token}`
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTop3(response['data'])
        // return navigate('/')
      } else {
        setTop3([])
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }

  const GetViewsPerDay = async () => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/viewsperday`, {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTotlaViewsPerDay(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }


  const GetViewsPerMonth = async () => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/viewspermonth`, {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTotlaViewsPerMonth(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }


  const GetMostvisitedhours = async () => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL_Documents}/views/mostvisitedhours`, {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setMostvisitedhours(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }

  const GetMostvisitedDays = async () => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL_Documents}/views/mostvisiteddays`, {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setMostvisitedDays(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }


  const GetWhatsAppMessages = async (GetAllData) => {
    // setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/categorie/get_whatsapp${DateSearch && !GetAllData ? '?date_start=' + DateSearch : ''}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Auth?.token}`
        },
      });

      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setWhatsApp(response['data'])
        // return navigate('/')
      }



      // setLoading(false)


    } catch (error) {
      // console.error(error.message);
      // setLoading(false)

    }
  }

  useEffect(() => {
    // setLoading(true)

    // ValidateToken();
    // GetClientsPerCat();
    // GetViewsPerDay();
    // GetViewsPerMonth();
    // GetTop3Agents();
    // GetMostvisitedhours();
    // GetMostvisitedDays();

  }, [])


  useEffect(() => {
    // ValidateToken();
    // GetClientsPerCat();
    // GetTop3Agents();
    // GetWhatsAppMessages();
    GetTotalTraitement();



  }, [])

  function SearchFilter(GetAllData) {

    if (GetAllData) {
      setDateSearch('')
    }
    // ValidateToken(GetAllData);
    // GetClientsPerCat(GetAllData);
    // GetTop3Agents(GetAllData);
    // GetWhatsAppMessages(GetAllData);
    GetTotalTraitement(GetAllData);

  }
  const [Loading, setLoading] = useState(false)

  const [TotalTraitement, setTotalTraitement] = useState('')

  const GetTotalTraitement = async (GetAllData) => {
    setLoading(true)
    try {
      const { data: response } = await axios.post(`${process.env.REACT_APP_LOCAL_URL}/client/top_products${!GetAllData ? SearchPer == 1 ? '?date_start=' + DateSearch + '&type=1' : '?month=' + SelectedMonth + '&type=2' : ''}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Auth?.token}`
        },
      });
      console.log(response);


      // console.log(response['errorCode']);
      if (response['error'] == false) {

        setTotalTraitement(response['data'])
        // return navigate('/')
      }



      
      
    } catch (error) {
      // console.error(error.message);
      setLoading(false)
      
    }
    setLoading(false)
  }

  const [SearchPer, setSearchPer] = useState("1")

  const Months = [
    { name: 'Décembre 2025', value: '12-2025', year: 2025 },
    { name: 'Novembre 2025', value: '11-2025', year: 2025 },
    { name: 'Octobre 2025', value: '10-2025', year: 2025 },
    { name: 'Septembre 2025', value: '09-2025', year: 2025 },
    { name: 'Août 2025', value: '08-2025', year: 2025 },
    { name: 'Juillet 2025', value: '07-2025', year: 2025 },
    { name: 'Juin 2025', value: '06-2025', year: 2025 },
    { name: 'Mars 2025', value: '03-2025', year: 2025 },
    { name: 'Février 2025', value: "02-2025", year: 2025 },
    { name: 'Janvier 2025', value: "01-2025", year: 2025 },
    { name: 'Décembre 2024', value: "12-2024", year: 2024 },
    { name: 'Novembre 2024', value: "11-2024", year: 2024 },
    { name: 'Octobre 2024', value: "10-2024", year: 2024 },
    { name: 'Septembre 2024', value: "09-2024", year: 2024 },
    { name: 'Août 2024', value: "08-2024", year: 2024 },
    { name: 'Juillet 2024', value: "07-2024", year: 2024 },
    { name: 'Juin 2024', value: "06-2024", year: 2024 },
    { name: 'Mai 2024', value: "05-2024", year: 2024 },
    { name: 'Avril 2024', value: "04-2024", year: 2024 },
    { name: 'Mars 2024', value: "03-2024", year: 2024 },
    { name: 'Février 2024', value: "02-2024", year: 2024 },
    { name: 'Janvier 2024', value: "01-2024", year: 2024 }

    // { name: 'Septembre 2024', value: 9, year: 2024 },
    // { name: 'Août 2024', value: 8, year: 2024 },
    // { name: 'Juillet 2024', value: 7, year: 2024 },
    // { name: 'Juin 2024', value: 6, year: 2024 },
    // { name: 'Mai 2024', value: 5, year: 2024 },
    // { name: 'Avril 2024', value: 4, year: 2024 },
    // { name: 'Mars 2024', value: 3, year: 2024 },
    // { name: 'Février 2024', value: 2, year: 2024 },
    // { name: 'Janvier 2024', value: 1, year: 2024 }
  ];

  const [SelectedMonth, setSelectedMonth] = useState("")


  return (
    <div className='dashboard'>


      <div className=''>
        <div className=''>

          <Menu MenuShow={MenuShow} setMenuShow={setMenuShow} />

        </div>
        <div className='page-client pt-lg-5' style={{ marginLeft: windowSize.innerWidth > 992 ? (MenuShow == true ? '328px' : '89px') : '0px' }}>
          <div className='menu-mobile-section'>
            <svg onClick={() => setMenuShow((p) => !p)} xmlns="http://www.w3.org/2000/svg" width="22.575" height="22.453" viewBox="0 0 22.575 22.453">
              <g id="Groupe_429" data-name="Groupe 429" transform="translate(-177.5 120.5)">
                <line id="Ligne_82" data-name="Ligne 82" x2="22.575" transform="translate(177.5 -119.5)" fill="none" stroke="#fff" stroke-width="2" />
                <line id="Ligne_83" data-name="Ligne 83" x2="22.575" transform="translate(177.5 -109.273)" fill="none" stroke="#fff" stroke-width="2" />
                <line id="Ligne_84" data-name="Ligne 84" x2="22.575" transform="translate(177.5 -99.047)" fill="none" stroke="#fff" stroke-width="2" />
              </g>
            </svg>
          </div>
          <div className='page-title'>Top 20 Produits <span>Diar Dzair</span></div>
          <div className='client-information mt-5'>
            <div className='container'>

              <div className='container-etat'>
                <div className={`btn-etat ${SearchPer == 1 ? "btn-etat-active" : ""}`} onClick={(e) => setSearchPer(1)}>Par Jour</div>
                <div className={`btn-etat ${SearchPer == 2 ? "btn-etat-active" : ""}`} onClick={(e) => setSearchPer(2)}>Par Mois</div>

              </div>

              {SearchPer == 1 ? <div className='d-flex justify-content-center mt-2 mb-4 flex-wrap align-items-end'>
                {/* {DateSearch ? <div className="x me-2" onClick={()=> SearchFilter(true)}>
                X
              </div> : ''} */}
                <div className='me-2' style={{ width: '180px' }}>
                  <label style={{ fontSize: '13px' }}>Par Date</label>

                  <input type="date" onChange={(e) => setDateSearch(e.target.value)} value={DateSearch} className="form-control me-3" id="inputEmail4" />
                </div>
                {/* <div style={{ width: '180px' }}>
                                    <label style={{ fontSize: '13px' }}>Date de fin</label>

                                    <input type="date" onChange={(e) => setDonwloadDateEnd(e.target.value)} value={DonwloadDateEnd} className="form-control me-3" id="inputEmail4" />
                                </div> */}
                <div className='search-btn-dashboard' onClick={() => SearchFilter()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30.621" height="30.621" viewBox="0 0 30.621 30.621">
                    <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(1.5 1.5)">
                      <path id="Tracé_1" data-name="Tracé 1" d="M28.5,16.5a12,12,0,1,1-12-12,12,12,0,0,1,12,12Z" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                      <path id="Tracé_2" data-name="Tracé 2" d="M31.5,31.5l-6.525-6.525" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                    </g>
                  </svg>


                </div>
              </div> : ""}


              {SearchPer == 2 ?
                <div className='d-flex justify-content-center mt-2 mb-4 flex-wrap align-items-center'>
                  <div className="mb-3 mt-1 me-3">
                    {/* <input type="text" onChange={(e) => setActedenaissance(e.target.value.replace(/[^0-9]+/g , ''))} value={Actedenaissance} className="form-control me-2" id="inputPassword4" /> */}
                    <label style={{ fontSize: '13px' }}>Par Mois</label>
                    <select style={{ maxWidth: "300px" }} class="form-select" aria-label="Default select example" onChange={(e) => setSelectedMonth(e.target.value)}>
                      <option disabled selected={SelectedMonth == ''}>Veuillez sélectionner le Mois</option>
                      {Months?.length > 0 && Months?.map((item, i) => (
                        <option selected={SelectedMonth == item?.value} value={item?.value}>{item?.name}</option>
                      ))
                      }
                    </select>
                    {/* <div className='err-cart-sum'>{Showerrors && errors?.Motif !== '' ? errors?.Motif : ''}</div> */}
                  </div>
                  <div className='search-btn-dashboard' onClick={() => SelectedMonth ? SearchFilter() : ""}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30.621" height="30.621" viewBox="0 0 30.621 30.621">
                      <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(1.5 1.5)">
                        <path id="Tracé_1" data-name="Tracé 1" d="M28.5,16.5a12,12,0,1,1-12-12,12,12,0,0,1,12,12Z" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                        <path id="Tracé_2" data-name="Tracé 2" d="M31.5,31.5l-6.525-6.525" transform="translate(-4.5 -4.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                      </g>
                    </svg>


                  </div>
                </div> : ""}
                {Loading ? <LoadData /> : ''}
                <main className='mt-2 analytic-list'>
                    <ol className="gradient-list">
                    
                    {!Loading && TotalTraitement?.length > 0 && TotalTraitement?.map((item,i) => (
                        <>
                        <li className="i3mal-pages-li" key={`OurVision2${item['id']}`}>
                            <h6 className='mb-0'><b>Produit :</b> {item?.nom}</h6>
                            <div className='mb-0'><b>Total :</b> {item?.total}</div>

                            {/* <div className='mb-2'><b>Status :</b> {onlyNumbers(item?.Status) ? FindActionPerId(item?.Status) : ''}</div>
                            <div><b>Déscription : </b>{item?.description ? item?.description :  <b>(Pas mentionné)</b>}</div> */}
                            
                            
                            </li>
                           {TotalTraitement?.length != i+1 ? <div data-aos="fade-down" className="wafeer-vertical-separation mt-3" /> : ''} </>
                        ))
                    }
                    </ol>
                </main>
            </div>
          </div>


        </div>
      </div>

    </div>
  )
}

export default TopProducts 